import script from "./DeleteVacancyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteVacancyModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteVacancyModal.vue?vue&type=style&index=0&id=01b76291&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b76291"]])

export default __exports__